import React from "react";
import {Document, Page, Text, View, StyleSheet, Font, Image} from "@react-pdf/renderer";
import src1 from "assets/styles/fonts/Manrope-Bold.ttf";
// import src2 from "../assets/styles/fonts/Manrope-Medium.ttf";
import RightCircleIcon from "assets/images/right_circle_tick.png";
import {
    WORK_PROCESS,EXISTING_TITLE,RAPID_CODE,JOURNEY_WORKER,
    CYBER_SECURITY,CODE,CYBER_TEXT,RTI,RTI_DESC,OJT,OJT_DESC,PROFICIENT,PROFICIENT_DESC,COMPLETION_D,COMPLETION_DATE,COMPLETION_DATE_DESC
  } from "resources/constants/strings.js";
  import dayjs from "dayjs";

Font.register({
  family: "Manrope-Bold",
  src: src1,
  fontStyle: "normal",
  fontWeight: "bold",
});

// Create styles
const styles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    fontSize: 11,
    paddingTop: 30,
    paddingLeft: 60,
    paddingRight: 60,
    lineHeight: 1.5,
    flexDirection: "column",
    paddingBottom: "70px",
    height: "600px",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  titleContainer: {
    // flexDirection: 'row',
    marginTop: 24,
    display: "block",
    width: "100%",
  },
  reportTitle: {
    color: "#000",
    // letterSpacing: "1px",
    fontSize: 14,
    textAlign: "center",
    textTransform: "uppercase",
    display: "block",
    width: "100%",
    fontFamily: "Manrope-Bold",
  },
  reportTitlesub: {
    color: "#000",
    fontSize: 13,
    textAlign: "center",
    textTransform: "uppercase",
    display: "block",
    width: "100%",
    // marginTop: 10,
    fontFamily: "Manrope-Bold",
  },
  subTitle: {
    color: "#000",
    fontSize: 10,
    textAlign: "left",
    display: "block",
    width: "100%",
  },
  subTitleMain: {
    fontSize: 16,
    marginBottom: 10,
    fontFamily: "Manrope-Bold",
  },
  main: {
    fontFamily: "Manrope-Bold",
  },
  tableContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 24,
    borderTopWidth: 1,
    borderColor: "#000",
  },
  row: {
    flexDirection: "row",
    borderBottomColor: "#000",
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    alignItems: "center",
    fontStyle: "bold",
    width: "100%",
    display: "block",
    fontSize: "8px",
  },
  slno: {
    width: "4%",
    textAlign: "left",
    borderRight: "1px solid #000",
    minHeight: "48px",
    padding: "5px",
  },
  description: {
    width: "50%",
    textAlign: "left",
    borderRight: "1px solid #000",
    minHeight: "48px",
    padding: "5px",
  },
  bc: {
    backgroundColor: "#faebd4",
  },
  rti: {
    width: "13%",
    borderRight: "1px solid #000",
    textAlign: "center",
    minHeight: "48px",
    padding: "5px",
  },
  ojt: {
    width: "16%",
    borderRight: "1px solid #000",
    textAlign: "center",
    minHeight: "48px",
    padding: "5px",
  },
  task: {
    width: "15%",
    borderRight: "1px solid #000",
    textAlign: "center",
    minHeight: "48px",
    padding: "5px",
  },
  date: {
    width: "15%",
    textAlign: "center",
    minHeight: "48px",
    padding: "5px",
  },
  logo: {
    width: 10,
    height: 10,
    marginLeft: "auto",
    marginRight: "auto",
  },
  pageNumbers: {
    position: "absolute",
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: "center",
  },
  fulllength: {
    width:"80%",
    display: "flex",
    flexDirection: "row",
    margin:"0 10%",
    fontSize: 13,
    fontFamily: "Manrope-Bold",
  },
  spaceLeft: {
    width: "50%",
    display: "flex",
    flexDirection: "row",
  },
 
});

// Create Document Component
const PdfExport = (data) => {
  let uniqueDolList = data?.data?.LearnerChecklist

  // data?.data?.DOLChecklistTemplate?.criteria_list?.filter(
  //   (element, index, array) =>
  //     array.findIndex(
  //       (t) => t.category_description === element.category_description
  //     ) === index
  // );

  const filteredData = (data = [], description) => {
    return data.filter(
      (element) => description === element.category_description
    );
  };
  return (
    <Document>
      <Page size="A4" style={styles.page} wrap={false}>
        <View style={styles.titleContainer}>
          <Text style={styles.reportTitle}>{WORK_PROCESS}</Text>
          <Text style={styles.reportTitle}>{CYBER_SECURITY}</Text>
          <Text style={styles.reportTitle}>{EXISTING_TITLE}</Text>
          <View style={styles.fulllength}>
              <Text style={styles.spaceLeft}>{CODE}</Text>
              <Text style={{textAlign: "right",flex: 1, display: "flex", flexDirection: "row"}}>{RAPID_CODE}</Text>
          </View>
        </View>
        <View style={styles.titleContainer}>
          <Text style={styles.subTitleMain}>
            {CYBER_TEXT}
          </Text>
          <Text style={styles.subTitle}>
            <Text style={styles.main}>{RTI}{" - "}</Text>
            {
              RTI_DESC
            }
          </Text>
          <Text style={styles.subTitle}>
            <Text style={styles.main}>{OJT}{" - "}</Text>
            {OJT_DESC}
          </Text>
          <Text style={styles.subTitle}>
            <Text style={styles.main}>{PROFICIENT}{" - "}</Text>
            {PROFICIENT_DESC}
          </Text>
          <Text style={styles.subTitle}>
            <Text style={styles.main}>{COMPLETION_D}{" - "}</Text>
            {COMPLETION_DATE_DESC}
          </Text>
        </View>
        <View style={styles.tableContainer} wrap>
          {uniqueDolList?.Category?.map((item, index) => (
            <View wrap={false} key={index}>
              <View style={styles.row} >
                <Text style={[styles.slno, styles.bc]}>{index+1}</Text>
                <Text style={[styles.description, styles.bc]}>
                  {item?.CategoryName}
                </Text>
                {/* <Text style={[styles.rti, styles.bc]}>{OJT}</Text> */}
                <Text style={[styles.ojt, styles.bc]}>{PROFICIENT}</Text>
                <Text style={[styles.task, styles.bc]}>{COMPLETION_DATE}</Text>
                <Text style={[styles.date, styles.bc]}>{JOURNEY_WORKER}</Text>
              </View>
              {item?.Criteria?.map((itemData, indexItem) => (
                <View style={styles.row} key={indexItem}>
                  <Text style={styles.slno}>{(indexItem+10).toString(36)}</Text>
                  <Text style={styles.description}>
                    {itemData?.CriteriaName}
                  </Text>
                  {/* <Text style={styles.rti}>{itemData?.OJT?.CompletionStatus ? <Image style={styles.logo} src={RightCircleIcon} /> : ""}</Text> */}
                  <Text style={styles.ojt}>{ itemData?.LearnerProficientStatus?.CompletionStatus  && itemData?.MentorProficientStatus?.CompletionStatus ? <Image style={styles.logo} src={RightCircleIcon} /> : ""}</Text>
                  <Text style={styles.task}>{itemData?.FinalApprovalStatus?.CompletionDate ? dayjs(itemData?.FinalApprovalStatus?.CompletionDate).format('YYYY-MM-DD') : ''}</Text>
                  <Text style={styles.date}>{""}</Text>
                </View>
              ))}
            </View>
          ))}
        </View>
        <Text style={styles.pageNumbers} render={({ pageNumber, totalPages }) => (
        `${pageNumber} / ${totalPages}`
      )} fixed />
      </Page>
    </Document>
  );
};

export default PdfExport;
